import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

const SubscriptionPageSkeleton = () => {
  return (
    <div className="max-w-6xl mx-auto p-6 space-y-10">
      
      {/* Active Subscriptions Skeleton */}
      <section>
        <div className="flex items-center gap-2 mb-4">
          <Skeleton className="w-5 h-5 rounded-full" />
          <Skeleton className="h-6 w-56" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[...Array(2)].map((_, i) => (
            <Card
              key={i}
              className="border-2 border-green-200 bg-flup-surface shadow-md"
            >
              <CardHeader className="pb-2">
                <div className="flex items-start justify-between">
                  
                  <div className="flex gap-4">
                    <Skeleton className="w-16 h-16 rounded-lg" />
                    <div className="space-y-2">
                      <Skeleton className="h-4 w-36" />
                      <Skeleton className="h-3 w-24" />
                    </div>
                  </div>

                  <Skeleton className="h-6 w-20 rounded-full" />
                </div>
              </CardHeader>

              <CardContent className="space-y-4">
                <div className="bg-green-50 rounded-lg p-3 space-y-3">
                  <div className="flex justify-between">
                    <Skeleton className="h-4 w-20" />
                    <Skeleton className="h-5 w-24 rounded-full" />
                  </div>

                  <div className="flex justify-between">
                    <Skeleton className="h-4 w-28" />
                    <Skeleton className="h-4 w-20" />
                  </div>

                  <Skeleton className="h-4 w-full" />
                </div>

                <div className="flex gap-2">
                  <Skeleton className="h-10 flex-1 rounded-md" />
                  <Skeleton className="h-10 flex-1 rounded-md" />
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      {/* Inactive / Not Subscribed Skeleton */}
      <section>
        <div className="flex items-center gap-2 mb-4">
          <Skeleton className="w-5 h-5 rounded-full" />
          <Skeleton className="h-6 w-64" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[...Array(2)].map((_, i) => (
            <Card
              key={i}
              className="border-2 border-dashed border-flup-hairline-2 bg-white/50"
            >
              <CardHeader className="pb-2">
                <div className="flex items-start justify-between">
                  
                  <div className="flex gap-4">
                    <Skeleton className="w-16 h-16 rounded-lg" />
                    <div className="space-y-2">
                      <Skeleton className="h-4 w-36" />
                      <Skeleton className="h-3 w-24" />
                    </div>
                  </div>

                  <Skeleton className="h-6 w-28 rounded-full" />
                </div>
              </CardHeader>

              <CardContent className="space-y-4">
                <div className="bg-flup-surface-alt rounded-lg p-3 space-y-2">
                  <Skeleton className="h-4 w-3/4" />

                  {[...Array(3)].map((_, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <Skeleton className="w-4 h-4 rounded-full" />
                      <Skeleton className="h-4 w-40" />
                    </div>
                  ))}
                </div>

                <Skeleton className="h-10 w-full rounded-md" />
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
};


export default SubscriptionPageSkeleton;